export default __webpack_public_path__ + "static/contacts-2928f9c5a0c9eed7840933b7dfd8eba5.jpg";